import { useNavigation } from '../navigation/navigation.hooks';
import { useLocationListener, useRouterLocation } from '../routing/location.hook';

export const useShopByLookParams = () => {
	const { search } = useRouterLocation();
	const navigate = useNavigation();
	const locationListener = useLocationListener();
	const queryParams = new URLSearchParams(search);

	const favorites = queryParams.get('favorites');
	const rooms = queryParams.getAll('room') || [];
	const styles = queryParams.getAll('style') || [];

	const updateGroupSelections = (groupName: 'room' | 'style', group: string[], newValue: string) => {
		if (group.includes(newValue)) {
			queryParams.delete(groupName);
			group.filter((selection) => selection !== newValue).forEach((selection) => queryParams.append(groupName, selection));
		} else if (group.length > 0) {
			queryParams.append(groupName, newValue);
		} else {
			queryParams.set(groupName, newValue);
		}
	};

	return {
		favorites,
		rooms,
		styles,
		update: (groupName: 'room' | 'style', newValue: string) => {
			if (groupName === 'room') {
				updateGroupSelections('room', rooms, newValue);
			}

			if (groupName === 'style') {
				updateGroupSelections('style', styles, newValue);
			}

			// included to prevent window from jumping to the top on every url change
			// should stay in place if user is just clicking around room filters
			const currentWindowPosition = window.scrollY;
			const unregisterListen = locationListener(() => {
				window.scrollTo(0, currentWindowPosition);
				unregisterListen();
			});

			navigate(`?${queryParams}`);
		}
	};
};
